import { useEffect, useState } from "react";
import app from "../components/app";

const taskSample = {
  task:"",
  created:"",
  modified:"",
  assigned:"",
  status:"",
}

function Tasks() {
  const [users, setUsers] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [task, setTask] = useState(JSON.parse(JSON.stringify(taskSample)));
  const [index, setIndex] = useState(null);
  const [filter, setFilter] = useState(app.taskFilter());
  

  useEffect(() => {
    app.fetchGet("/tasks").then(function(response){
      //console.log(response)
      const nextTasks = [];
      for(var key in response) {
        nextTasks.push({
          id:key,
          data:response[key]
        })
      }
      setTasks(nextTasks.sort((a, b) => a.data.status.toLocaleUpperCase() < b.data.status.toLocaleUpperCase() ? -1 : 1));
    });
    app.fetchGet("/users").then(function(response){
      //console.log(response)
      const nextTasks = [];
      for(var key in response) {
        nextTasks.push({
          id:key,
          data:response[key]
        })
      }
      console.log(nextTasks);
      setUsers(nextTasks);
    });
    app.fetchGet("/statuses").then(function(response){
      //console.log(response)
      const nextStatuses = [];
      for(var key in response) {
        nextStatuses.push({
          id:key,
          data:response[key]
        })
      }
      console.log(nextStatuses);
      setStatuses(nextStatuses);
    });
  }, []);
  const addTask = function() {
    if(index !== null) {
      addUpdate();
      return false;
    }
    if(task.task === "") {
      alert("Please enter task!");
      return false;
    }
    const created = Date.now();
    task["created"] = created;
    task["modified"] = created;
    app.fetchPost("/tasks", task).then(function(response){
      //console.log(response);
      document.querySelector("#task").value = "";
      setTasks([...tasks, {id:response.name, data:task}])
      setTask(JSON.parse(JSON.stringify(taskSample)));
    });
  }
  const addUpdate= function() {
    if(task.task === "") {
      alert("Please enter task!");
      return false;
    }
    task["modified"] = Date.now();
    app.fetchPut(`/tasks/${tasks[index].id}`, task).then(function(response){
      //console.log(response);
      document.querySelector("#task").value = "";
      const nextTasks = [...tasks];
      nextTasks[index].data = task;
      setTasks(nextTasks);
      setTask(JSON.parse(JSON.stringify(taskSample)));
      setIndex(null);
    });
  }
  const editTask = function(index) {
    setIndex(index);
    setTask(tasks[index].data);
    document.querySelector("#task").value = tasks[index].data.task;
  }
  const onInput = function(event){
    const obj = event.currentTarget;
    const nextTask = JSON.parse(JSON.stringify(task));
    nextTask[obj.id] = obj.value;
    setTask(nextTask)
  }
  const getUser = function(index){
    const nexUser = users.filter(function(v){
      if(tasks[index].data.assigned === v.id) {
        return true;
      }
      return false;
    });
    if(nexUser[0]) {
      return nexUser[0].data;
    }
    return {};
  }
  const getStatus= function(index){
    const nextStatus = statuses.filter(function(v){
      if(tasks[index].data.status === v.id) {
        return true;
      }
      return false;
    });
    if(nextStatus[0]) {
      return nextStatus[0].data;
    }
    return {};
  }
  const updateFilter= function(key, value){
    const nextFilter = JSON.parse(JSON.stringify(filter));
    if(nextFilter[key].indexOf(value) !== -1) {
      nextFilter[key].splice(nextFilter[key].indexOf(value), 1);
    }
    else {
      nextFilter[key].push(value);
    }
    app.taskFilter(nextFilter.users, nextFilter.statuses);
    setFilter(nextFilter);
  }
  console.log(filter);
  return <div className="container-fluid p-4 task-list">
    <h1>Task List</h1>

    <div className="w-100 pt-2 pb-2">

    <div className="btn-group me-2 btn-group-sm">
      {
users.map(function(v){
  let active = "";
  if(filter.users.indexOf(v.id) !== -1) {
    active = "active";
  }
return <button type="button" className={`btn btn-outline-secondary ${active}`} onClick={() => updateFilter("users", v.id)}>{v.data.name}</button>
})
      }
  
  
</div>

<div className="btn-group me-2 btn-group-sm">
      {
statuses.map(function(v){
  let active = "";
  if(filter.statuses.indexOf(v.id) !== -1) {
    active = "active";
  }
return <button type="button" className={`btn btn-outline-secondary ${active}`} onClick={() => updateFilter("statuses", v.id)}>{v.data.title}</button>
})
      }
  
  
</div>

    
    </div>

  

    <div className="w-100">
   
    <ul className="list-group">
      {
        tasks.map(function(v, i){
          const status = getStatus(i);
          if(filter.users.length) {
            if(filter.users.indexOf(v.data.assigned) === -1) {
              return null;
            }
          }
          if(filter.statuses.length) {
            if(filter.statuses.indexOf(v.data.status) === -1) {
              return null;
            }
          }
          return <li key={v.id} className="list-group-item">
            {v.data.task}
<div className="float-end d-flex">
<div className="btn-group d-none">
  <button type="button" className="btn btn-danger dropdown-toggle show" data-bs-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <ul className="dropdown-menu show ">
    <li><a className="dropdown-item" href="#">Action</a></li>
    <li><a className="dropdown-item" href="#">Another action</a></li>
    <li><a className="dropdown-item" href="#">Something else here</a></li>
    <li><hr className="dropdown-divider" /></li>
    <li><a className="dropdown-item" href="#">Separated link</a></li>
  </ul>
</div>

<span class="badge p-2 no-select me-2" style={{background:status.color}}>{status.title}</span>
<span class="badge p-2 no-select" style={{background:"blue"}}>{getUser(i).name}</span>
 
</div>
          </li>
        })
      }
    </ul>

    
    </div>

  </div>
}

export default Tasks;
